import { Injectable } from '@angular/core';
import { gql, Subscription } from 'apollo-angular';

const BULK_STATUS_CHANGE_SUBSCRIPTION = gql`
subscription bulkStatusChangeEvents{
  onBulkStatusChangeEvent {
    data {
      operationId
      state
      total
      eligible
      processed
      updated
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class BulkStatusChangeSubscriptionService extends Subscription {

  document = BULK_STATUS_CHANGE_SUBSCRIPTION;
}
